const disabledOpacity = 0.5

export default {
  disabledOpacity,
  zIndex: {
    menu: 5000,
    overlay: 6000,
  },
  headerWidthBreakpoint: '576px',
  mobileHeaderHeight: '50px',
  desktopHeaderHeight: '72px',
}
